import { fetchAll, fetchFiltered, add, edit, show, fetchByCompany } from "@/api/drivergroup";

const state = {
  all: [],
  isLoading: false,
  driverGroupById: null,
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchAll({ dispatch, commit }) {
    try {
      const driverGroups = await fetchAll();
      commit("setAll", driverGroups);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchById({ dispatch, commit }, id) {
    try {
      const driverGroup = await show(id);
      commit("setDriverGroupById", driverGroup);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchFiltered({ dispatch, commit }, queriesParams) {
    try {
      const driverGroups = await fetchFiltered(queriesParams);
      commit("setAll", driverGroups);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async edit({ dispatch, commit }, { id, data }) {
    commit("setLoading", true);
    try {
      await edit(id, data);
      return true;
    } catch (e) {
      dispatch("notify/error", msg, { root: true });
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async create({ dispatch, commit }, status) {
    commit("setLoading", true);
    try {
      await add(status);
      return true;
    } catch (e) {
      dispatch("notify/error", msg, { root: true });
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async fetchByCompany({ dispatch, commit }, company) {
    try {
      dispatch("overlay/show", true, { root: true });

      const driverGroups = await fetchByCompany(company);
      commit("setAll", driverGroups);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    } finally {
      dispatch("overlay/show", false, { root: true });
    }
  },
};

const mutations = {
  setAll(state, frequency) {
    state.all = frequency;
  },

  setDriverGroupById(state, driverGroup) {
    state.driverGroupById = driverGroup;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },

  cleanState(state) {
    state.all = [];
    state.isLoading = false;
    state.driverGroupById = null;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
